import { CustomJobAlertPageView } from './CustomJobAlertPageView'
export default CustomJobAlertPageView
